<template>
    <hmenu></hmenu>

          <main>
            <section class="breadcrumb-height ns-breadcrumb-area" style="min-height: 300px; background-image: url('/assets/img/breadcrumb/breadcrumb-bg.jpg');" >
                <img src="/assets/img/breadcrumb/shape-1.png" alt="" class="ns-breadcrumb-shape-1">
                <img src="/assets/img/breadcrumb/breadcrumb-map.png" alt="" class="ns-breadcrumb-map">
                <img src="/assets/img/breadcrumb/shape-2.png" alt="" class="ns-breadcrumb-shape-2">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div class="ns-breadcrumb-wrap text-center">
                                <h2 class="ns-breadcrumb-title">Sistem për orientimin e parkimit</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <div class="ns-project-details-area pt-115 pb-70">
                <div class="container">

                    <div class="row">
                        <div class="col-xl-4 col-lg-5 col-md-5">
                            <div class="ns-project-details-img-2 w_img mb-40">
                                <img src="asetet/sesnor1.jpg" alt="">
                            </div>
                        </div>
                        <div class="col-xl-8 col-lg-7 col-md-7">
                            <div class="ns-project-details-content mb-40">
                                <div class="ns-project-details-list">
                                    <h4>Sensorë Ultrasonikë për Menaxhimin e Parkimit</h4>
                                    <p class="ns-project-details-text">Gpro ofron zgjidhje moderne për sistemet e parkimit përmes sensorëve ultrasonikë të avancuar, të cilët mundësojnë monitorim të saktë dhe në kohë reale të çdo vendi parkimi. </p>

                                    <p class="ns-project-details-text">Sensorët instalohen direkt mbi çdo vend parkimi dhe detektojnë automatikisht praninë e automjetit. Kur një vend parkimi është i zënë, sistemi ndryshon statusin e tij menjëherë, duke lehtësuar menaxhimin dhe orientimin e automjeteve brenda parkingut.</p>

                                    <div>
                                      <h4>Përparësitë kryesore</h4>
                                      <ul>
                                          <li>1. Detektim i saktë i automjeteve në çdo vend parkimi.</li>
                                          <li>2. Monitorim në kohë reale i gjendjes së parkingut.</li>
                                          <li>3. Indikator vizual (LED) për statusin e vendit të parkimit.</li>
                                          <li>4. Integrim me sistemet qendrore të menaxhimit të parkimit.</li>
                                          <li>5. Përmirësim i rrjedhës së trafikut brenda parkingut.</li>
                                          <li>6. Reduktim i kohës së kërkimit për vend parkimi.</li>
                                      </ul>
                                      <br>
                                      <br>
                                      <h4>Sistemi i integruar i menaxhimit</h4>
                                      <p class="ns-project-details-text">Të dhënat e mbledhura nga sensorët transmetohen në kontrolluesin qendror, i cili i përpunon dhe i shfaq në ekranet udhëzuese të parkingut. Në këtë mënyrë, drejtuesit e automjeteve udhëzohen në mënyrë efikase drejt vendeve të lira, duke rritur komoditetin dhe organizimin e hapësirës së parkimit.
                                        <br>
                                      Me këtë teknologji, Gpro ofron një zgjidhje inteligjente dhe të besueshme për parkingje moderne dhe të automatizuara.
                                      </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>


                </div>
            </div>


        </main>


    <Footer></Footer>
</template>

<script>
    import hmenu from './header.vue'
    import Footer from './Footer.vue'

    export default {

        data () {
            return {
               selected:'kioska'
            }
        },


        methods:{

            tabClick(type){
                this.selected = type
            }

        },

        mounted:function(){

        },


        components: {
            hmenu,
            Footer,
         
        },


        mounted:function(){
            window.scrollTo({top: 0, behavior: 'smooth'});
        }


    }

</script>

